import React, {useState,useEffect, useRef} from 'react';
import Icon from '../../assets/icons/icon';

function Dropdown({inputLabel, inputValue, changeHandler, blurHandler, errorMsg = "", inputType="text", disabled = false, helperMsg='', options = [], customStyles = {}}) {

    const errorStyles = { alignSelf: 'stretch', paddingLeft: 14, paddingRight: 14, paddingTop: 23, paddingBottom: 23, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, overflow: 'hidden', border: '1px #FDA29B solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex' }
    const regStyles = {alignSelf: 'stretch', paddingLeft: 14, paddingRight: 14, paddingTop: 23, paddingBottom: 23, background: '#F8F8F8', boxShadow: '0px 1px 2px rgba(16, 24, 40, 0.05)', borderRadius: 8, overflow: 'hidden', border: '1px #D0D0D0 solid', justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'inline-flex'}

    const selectRef = useRef()

    useEffect(()=>{
        selectRef.current.value = inputValue
    }, [inputValue])

    const handleChange = (e) => {
        if(changeHandler !== undefined){
            changeHandler(e)
        }
    }
    return (
        <>
                <div style={{width: '100%', height: '100%', flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', gap: 8, display: 'inline-flex', ...customStyles}}>
                    <div className='dropdown_outbox' style={{alignSelf: 'stretch', height: 66, flexDirection: 'column', justifyContent: 'flex-start', alignItems: 'flex-start', display: 'flex'}}>
                        <div style={{justifyContent: 'flex-start', alignItems: 'flex-end', gap: 4, display: 'inline-flex'}}>
                            <div style={{color: '#707070', fontSize: 14, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>{inputLabel}</div>
                        </div>
                        <div className='dropdown_pading'  style={errorMsg.length > 0 ? errorStyles : regStyles}>
                            <div style={{ flex: '1 1 0', height: 11, justifyContent: 'flex-start', alignItems: 'center', gap: 8, display: 'flex' }}>
                                    <select disabled={disabled} onChange={e => handleChange(e)} ref={selectRef} style={{ flex: '1 1 0', color: '#2F2F2F', fontSize: 16, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word',background: 'rgb(248, 248, 248)', border: 'solid 1px rgb(248, 248, 248)' }}>
                                        {options.map((o, index) => (
                                            <option value={o.value} key={`dropdownoption${index}-${o.label}-${o.value}`}>{o.label}</option>
                                        ))}
                                    </select>
                            </div>
                            {errorMsg.length > 0 && (
                                <div style={{ display: 'inline-flex', alignItems: 'center' }}>
                                    <Icon name="q-alert-octagon" size={20} className="" adjust="fontello" color='#F95951' viewBox="0 0 1024 700"/>
                                </div>
                            )}
                        </div>
                        <div style={{ alignSelf: 'stretch', color: '#DE3F35', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word' }}>{errorMsg}</div>
                        {helperMsg.length > 0 && (
                            <div style={{alignSelf: 'stretch', color: '#8D8D8D', fontSize: 12, fontFamily: 'Montserrat', fontWeight: '400', wordWrap: 'break-word'}}>{helperMsg}</div>
                        )}
                    </div>
                </div>
        </>
    )
}

export default Dropdown;
